import React from 'react';
import * as Fi from 'react-icons/fi';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';

import { Table, Location } from 'services/action';
import { FormLocation } from 'ui/screens/authorized/_shared';

const initialState = {
  isUpdate: false,
  isDelete: false,
  privilege: null,
};

const TableAction = ({ data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateForm = useSelector((state) => state.Activity);
  const StateTable = useSelector(
    (state) => state?.Table?.data['customer.location']
  );
  const [{ isDeleteShow, isUpdate, privilege }, setState] =
    React.useState(initialState);

  const clearState = () => {
    setState({ ...initialState });
  };

  const $handleClose = () => {
    clearState();
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Location.$delete(data?.id));
    if (del?.message === 'success') {
      $resetTable();
      $handleClose();
    }
  };

  const $resetTable = async () => {
    $handleClose();
    Dispatch(Table.$reload('customer.location', StateTable));
  };

  const $getPrivilege = async () => {
    const payload = {};

    const location = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.location',
    });

    if (location) {
      payload.location = location;
    }

    setState((prevState) => ({
      ...prevState,
      privilege: payload,
    }));
  };

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  if (!Session?.privileges || privilege?.location?.action === 'manage') {
    return (
      <div>
        <div className="d-flex flex-row align-items-center justify-content-end gap-2">
          <div>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
            >
              <div
                className="btn btn-ghost-primary p-1"
                onClick={() => {
                  setState((prevState) => ({
                    ...prevState,
                    isUpdate: true,
                  }));
                }}
              >
                <Fi.FiEdit size={18} />
              </div>
            </OverlayTrigger>
          </div>
          <div>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
            >
              <div
                className="btn btn-ghost-danger p-1"
                onClick={() => {
                  setState((prevState) => ({
                    ...prevState,
                    isDeleteShow: true,
                  }));
                }}
              >
                <Fi.FiTrash2 size={20} />
              </div>
            </OverlayTrigger>
          </div>
        </div>

        {/* modal delete */}
        <Modal
          show={isDeleteShow}
          onHide={$handleClose}
          backdrop="static"
          centered
          className="text-center"
          size="small"
        >
          <Modal.Body>
            <div className="btn-close" onClick={$handleClose} />
            <div className="modal-status bg-danger" />
            <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-danger fw-semibold">
              Data yang sudah dihapus tidak bisa dipulihkan
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="row w-100">
              <div className="col">
                <Button
                  variant="white"
                  className="w-100"
                  onClick={$handleClose}
                >
                  Batal
                </Button>
              </div>
              <div className="col">
                <Button
                  variant="danger"
                  className={
                    StateForm?.processing ? ' btn-loading w-100' : 'w-100'
                  }
                  onClick={$handleDelete}
                  disabled={StateForm?.processing}
                >
                  Hapus
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        {/* modal update */}
        <Modal
          show={isUpdate}
          onHide={$handleClose}
          backdrop="static"
          centered
          scrollable
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Perbaharui Lokasi</Modal.Title>
          </Modal.Header>
          <FormLocation
            type={data?.type}
            onClose={() => {
              setState((prevState) => ({ ...prevState, isUpdate: false }));
            }}
            onSuccess={$resetTable}
            data={data}
            customer_id={StateTable?.filter?.customer_id}
          />
        </Modal>
      </div>
    );
  }

  return null;
};

export default TableAction;
